import styled from 'styled-components';

import { BasicSectionContainer } from '../../../../../style';
import { colors } from 'constants/colors';
import { styleSizes } from 'constants/styleSizes';

export const CreditCardDetailsContentContainer = styled(BasicSectionContainer)`
  min-width: 260px;
`;

export const CreditCardDetailsCardContainer = styled.div`
  width: 100%;
  max-width: 854px;
  padding: 32px;
  background: ${colors.white};
  box-sizing: border-box;
  -webkit-box-shadow: 0px 1px 3px 0px ${colors.accounMenuBorderShadowColor};
  -moz-box-shadow: 0px 1px 3px 0px ${colors.accounMenuBorderShadowColor};
   box-shadow: 0px 1px 3px 0px ${colors.accounMenuBorderShadowColor};
   border: 1px solid ${colors.signInBorderColor};
  .description {
    max-width: 790px;
    margin: 0 0 36px 0;
    font-size: 16px;
    line-height: 26px;
    color: ${colors.almostBlack};
  }

  .cardInfoRows {
    margin-bottom: 32px;
  }

  .cardInfoRow {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
  }

  .cardInfoRow:last-child {
    margin-bottom: 0;
  }

  .cardInfoLabel {
    min-width: 165px;
    margin-right: 16px;
    color: ${colors.almostBlack};
    font-size: 16px;
    line-height: 22px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .cardInfoValue {
    color: ${colors.almostBlack};
    font-size: 16px;
    line-height: 22px;
  }

  @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
    padding: 0;
    -webkit-box-shadow:none;
    -moz-box-shadow: none;
    box-shadow: none;
    border: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .description {
      margin-bottom: 32px;
      font-size: 16px;
      line-height: 24px;
    }

    .cardInfoLabel {
        min-width: auto;
        white-space: nowrap;
    }


    .cardInfoValue {
      font-size: 16px;
      line-height: 22px;
    }
  }
`;

export const CreditCardDetailsButton = styled.button`
  height: 48px;
  padding: 0 32px;
  border: none;
  background: ${colors.hoverBlue};
  color: ${colors.white};
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
`;